import type Store from "@ember-data/store";
import { registerDestructor } from "@ember/destroyable";

import { CnamManagerAdapter } from "parog-web/cnam-adapters/cnam-manager-adapter";
import DmpConnectJSAuthenticationContextAdapter from "parog-web/contexts/dmpconnect-js/authentication-context-adapter";
import type MedicModel from "parog-web/models/medic";
import type FetcherService from "parog-web/services/fetcher";
import type SemeiaFeaturesService from "parog-web/services/semeia-features";
import DmpConnectJSCardReaderAdapter from "./card-reader-adapter";
import DmpConnectJSDmpAdapter from "./dmp-adapter";
import DmpConnect from "./dmp-connect";
import DmpConnectJSInsiAdapter from "./insi-adapter";
import PinCodeManager from "./pin-code-manager";

export default class DmpConnectJSCnamManagerAdapter extends CnamManagerAdapter {
  declare authenticationContext: DmpConnectJSAuthenticationContextAdapter;
  declare cardReaderAdapter: DmpConnectJSCardReaderAdapter;
  declare dmpAdapter: DmpConnectJSDmpAdapter;
  declare dmpConnect: DmpConnect;
  declare insiAdapter: DmpConnectJSInsiAdapter;
  declare medic: MedicModel;
  override name = "dmpconnect-js";
  declare pinCodeManager: PinCodeManager;

  constructor(
    medic: MedicModel,
    store: Store,
    accessToken: string,
    fetcher: FetcherService,
    requestManager,
    semeiaFeaturesService?: SemeiaFeaturesService
  ) {
    super();
    this.pinCodeManager = new PinCodeManager(medic);
    this.dmpConnect = new DmpConnect(
      this.pinCodeManager,
      medic,
      accessToken,
      semeiaFeaturesService
    );
    this.cardReaderAdapter = new DmpConnectJSCardReaderAdapter(
      this.pinCodeManager,
      this.dmpConnect
    );
    this.authenticationContext = new DmpConnectJSAuthenticationContextAdapter(
      this.name,
      this.pinCodeManager,
      this.cardReaderAdapter,
      this.dmpConnect,
      medic,
      store,
      fetcher,
      requestManager
    );
    this.dmpAdapter = new DmpConnectJSDmpAdapter(
      this.dmpConnect,
      this.cardReaderAdapter,
      this.authenticationContext,
      medic,
      store
    );
    this.insiAdapter = new DmpConnectJSInsiAdapter(
      this.dmpConnect,
      this.authenticationContext
    );
    this.medic = medic;
    this.requestManager = requestManager;

    registerDestructor(this, async () => {
      await this.dmpConnect.closeSession();
    });
  }

  override async onDismiss(): Promise<void> {
    await this.dmpAdapter.closeSession();
  }
}
